import { useEffect } from "react";
import { useAppSelector } from "../../../Store";
import { UndefinedOptions } from "..";
import { ValueType } from "../../../Definitions";
import { gql, useQuery } from "@apollo/client";
import { selectAllSystemOptions, upsertSystemOptions } from "../../../Store/OptionsHandlers/optionsCombinedReducer";
import { useDispatch } from "react-redux";
import { BasicQueryInfoInput } from "../../../Services/Agrisys_GqlDataCaller/FeedDataCalls/GQLCalls/getFeedComponentsCall";

const SYSTEM_OPTIONS_QUERY = gql`
  query SystemOptions($domain: String!, $input: BasicQueryInfoInput!) {
    system {
      info(domain: $domain, input: $input) {
        id: system_id
        label: name
      }
    }
  }
`

interface SystemOptionsResult {
  system: {
    info: ValueType[]
  }
}


export const useSystemOptions = (includeUndefinedOption?: UndefinedOptions) => {
  const farm = useAppSelector(({ activeData }) => activeData.farm) ?? "";

  const fetchTime = useAppSelector(({optionsState}) => {if ("lastFetched" in optionsState.systemOptions && typeof optionsState.systemOptions.lastFetched === "number") {return optionsState.systemOptions.lastFetched}})
  const dispatch = useDispatch();
  const reduxOptions = useAppSelector(selectAllSystemOptions);
  const {data, loading} = useQuery<SystemOptionsResult, {domain: string, input: BasicQueryInfoInput}>(SYSTEM_OPTIONS_QUERY, {
   skip: !!reduxOptions.length || fetchTime !== undefined || (fetchTime && (Date.now()-fetchTime > 300000)),
    fetchPolicy: "no-cache",
    variables: {
      domain: farm,
      input: {fetchAmount: 500}
    }
  })

  useEffect(() => {
    if (!loading && data && !reduxOptions.length) {
      dispatch(upsertSystemOptions(data.system.info))
    }
  },[data, dispatch, loading, reduxOptions.length])

  
  let undefinedOption = null;
  if (includeUndefinedOption) {
    undefinedOption = includeUndefinedOption === "NaN" ?  { label: "no system", id: NaN } : { label: "no system", id: null}
  }


  return undefinedOption ? [undefinedOption, ...reduxOptions] as ValueType[]: reduxOptions;
};
